/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ManualEmailStepOverrideEmailBodyDoc } from './manualEmailStepOverrideEmailBodyDoc';
import type { ManualEmailStepOverrideEmailSubjectDoc } from './manualEmailStepOverrideEmailSubjectDoc';
import type { ManualEmailStepOverrideEmailThreadMode } from './manualEmailStepOverrideEmailThreadMode';

export interface ManualEmailStepOverride {
  type: 'manual_email';
  email_subject_doc?: ManualEmailStepOverrideEmailSubjectDoc;
  email_body_doc?: ManualEmailStepOverrideEmailBodyDoc;
  email_thread_mode?: ManualEmailStepOverrideEmailThreadMode;
  email_cc?: string[] | null;
  email_bcc?: string[] | null;
  email_include_sender_signature?: boolean | null;
  email_to_address?: string | null;
}
